module.exports = __webpack_public_path__ + "img/windows.d1384a94.png";